var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 26,
    viewBox: "0 0 124 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39515_29890)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39515_29890",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H124V26H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39515_29890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62923 19.0966L7.3772 18.6081L13.6646 14.4923C13.9071 14.3103 14.3498 14.33 14.6344 14.4923L22.4583 19.0383C22.7397 19.2006 22.7818 19.4843 22.5195 19.6473C20.5164 20.971 14.8967 25.0475 12.9556 25.6793C11.865 26.0449 10.0631 26.312 8.20228 25.2326L5.14838 23.4591L2.90366 22.1552C1.58974 21.3815 0.719356 20.2406 0.275818 18.7515C2.46013 20.6653 4.25892 20.6259 6.62446 19.0966H6.62923Z",
    fill: "url(#paint0_linear_39515_29890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99486 5.54592L9.0346 6.44253L9.07355 8.70532V17.264L9.03381 19.5268L8.99486 20.4234C8.8335 23.2338 9.70389 24.845 12.4541 25.7834C10.959 26.149 9.54173 25.9662 8.20873 25.1933L5.96322 23.909L2.90932 22.1158C1.11053 21.0561 0.421373 19.3858 0.178937 18.2843C9.10518e-05 17.5083 -0.0221654 15.3274 0.0167834 13.0056V12.9662C-0.0221654 10.6419 0.000885913 8.44059 0.178937 7.68738C0.421373 6.56623 1.10735 4.89671 2.90932 3.85671L5.96322 2.0635L8.20873 0.779255C9.54173 0.00555805 10.9558 -0.179593 12.4533 0.168649C9.70309 1.1275 8.8335 2.71507 8.99566 5.54829L8.99486 5.54592Z",
    fill: "url(#paint1_linear_39515_29890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99476 5.54589L9.0345 6.4425L9.15374 8.56189L7.37481 7.40056L6.62763 6.91208C4.28038 5.3828 2.46171 5.34341 0.278198 7.23826C0.500762 6.5465 0.864019 5.70898 1.55238 4.95577C1.94325 4.52067 2.40121 4.14971 2.90922 3.85668L5.15394 2.55195L5.96312 2.06347L8.20863 0.779227C8.71596 0.476815 9.26872 0.256591 9.84607 0.126863C10.8158 -0.0756218 11.7251 0.00552972 12.4342 0.166257C9.70379 1.12432 8.83579 2.71268 8.99794 5.54589H8.99476Z",
    fill: "#45FFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62923 6.91214L7.3772 7.40063L13.6646 11.5157C13.9071 11.6985 14.3498 11.6788 14.6344 11.5157L22.4583 6.97124C22.7397 6.80814 22.7818 6.52372 22.5195 6.36063C20.5164 5.03699 14.8967 0.961297 12.9556 0.32863C11.865 -0.0361574 10.0631 -0.303248 8.20228 0.776146L5.14838 2.54887L2.90366 3.8536C1.58974 4.62651 0.719356 5.76815 0.275818 7.25724C2.46013 5.34348 4.25892 5.38287 6.62446 6.91214H6.62923Z",
    fill: "url(#paint2_linear_39515_29890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03371 6.4426L9.07345 8.51945L7.37481 7.3983L6.62763 6.90902C4.28117 5.38054 2.4625 5.34114 0.278992 7.2352C0.501556 6.54345 0.864812 5.70672 1.55317 4.95272C1.94381 4.51769 2.40149 4.14673 2.90922 3.85363L5.15394 2.54969L5.96312 2.06042L8.20863 0.776175C8.71596 0.473763 9.26872 0.253539 9.84607 0.123811C10.8158 -0.0786736 11.7251 0.00247796 12.4342 0.163205C10.0074 0.733629 8.95581 2.46539 9.03689 6.43945L9.03371 6.4426Z",
    fill: "url(#paint3_linear_39515_29890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03371 19.5236L9.07345 17.424L7.37481 18.5459L6.62763 19.0344C4.28117 20.5833 2.4625 20.6227 0.278992 18.709C0.501556 19.4228 0.864812 20.2572 1.55317 21.0104C1.93868 21.4185 2.38222 21.8061 2.90922 22.1095L5.15394 23.4142L5.96312 23.8838L8.20863 25.1877C8.73325 25.4942 9.27932 25.6967 9.84607 25.8204C10.8158 26.0449 11.7251 25.9409 12.4342 25.781C10.0074 25.2295 8.95581 23.4985 9.03689 19.5268L9.03371 19.5236Z",
    fill: "url(#paint4_linear_39515_29890)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3984 17.7305C41.3882 19.504 39.366 20.5023 37.3637 20.5023C33.6843 20.5023 30.7925 17.6691 30.7925 13.9613C30.7925 10.2535 33.6843 7.40063 37.3637 7.40063C39.366 7.40063 41.3882 8.39888 42.3976 10.1724L42.5177 10.3749L40.1108 11.7182L39.9908 11.5551C39.3048 10.5774 38.3931 10.1889 37.2016 10.1889C35.0594 10.1889 33.8464 11.901 33.8464 13.9581C33.8464 16.0161 35.0403 17.7085 37.2016 17.7085C38.3541 17.7085 39.3437 17.3429 39.9908 16.3423L40.11 16.1792L42.5185 17.5225L42.3976 17.725L42.3984 17.7305ZM93.9777 16.9151L89.5486 7.68506H92.7027L95.4339 14.0196L98.142 7.68506H101.296L96.9282 16.8733V20.1958H93.9777V16.9151ZM52.1237 17.0978L47.3123 18.0141L46.7074 20.1958H43.7139L46.9491 9.53973C47.3545 8.21609 48.4673 7.40063 49.8424 7.40063C51.2175 7.40063 52.3304 8.21609 52.7342 9.53973L55.9693 20.1958H52.9782L52.1293 17.0971L52.1237 17.0978ZM62.9626 10.3749V20.1958H59.9897V10.3749H56.3095V7.68506H66.642V10.3749H62.9626ZM75.4579 17.2806L70.6045 18.0141L69.9765 20.1958H66.9846L70.2197 9.53973C70.6243 8.21609 71.7372 7.40063 73.1123 7.40063C74.4874 7.40063 75.6002 8.21609 76.004 9.53973L79.259 20.1958H76.2465L75.4579 17.2806ZM84.7595 17.506H90.5216V20.1958H84.5974C82.7565 20.1958 81.8082 19.3803 81.8082 17.4855V7.68821H84.7595V17.5091V17.506ZM108.637 10.3749H102.937V7.68506H109.285C110.721 7.68506 112.015 8.49973 112.015 10.0684C112.015 10.8642 111.63 11.6174 111.064 12.1681L105.867 17.506H111.73V20.1958H105.22C103.726 20.1958 102.593 19.3606 102.593 17.7699C102.593 17.0167 102.897 16.2414 103.422 15.7128L108.637 10.3749ZM117.716 10.2732V12.6369H123.459V15.2455H117.716V17.6092H124.003V20.1981H117.532C115.691 20.1981 114.743 19.3835 114.743 17.4886V10.3977C114.743 8.52257 115.694 7.68742 117.532 7.68742H123.9V10.2764H117.713L117.716 10.2732ZM48.1215 15.1447L51.3964 14.4726L50.305 10.4166C50.2438 10.1921 50.1238 10.0093 49.8615 10.0093C49.5992 10.0093 49.4768 10.1921 49.4179 10.4166L48.1239 15.1447H48.1215ZM71.3516 15.2652L74.7298 14.6554L73.5972 10.4166C73.5161 10.1921 73.3968 10.0093 73.1314 10.0093C72.8889 10.0093 72.7466 10.1921 72.6878 10.4166L71.3548 15.2652H71.3516Z",
    fill: "#414141"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39515_29890",
    x1: 12.1035,
    y1: 22.4493,
    x2: 21.3121,
    y2: 16.3711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39515_29890",
    x1: 10.1865,
    y1: 7.50792,
    x2: 10.2894,
    y2: 21.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00419C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2197FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39515_29890",
    x1: 12.7909,
    y1: 6.32065,
    x2: 25.4872,
    y2: 9.92816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EFFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B8AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_39515_29890",
    x1: 12.9268,
    y1: 6.01047,
    x2: 5.25313,
    y2: 6.76537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_39515_29890",
    x1: 12.5116,
    y1: 23.4955,
    x2: 9.78388,
    y2: 20.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39515_29890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.acf7c931ba5f7a6832ad49ce11a43231.svg";
export { ForwardRef as ReactComponent };